import { render, staticRenderFns } from "./AddCourse.vue?vue&type=template&id=622c6291&scoped=true"
import script from "./AddCourse.vue?vue&type=script&lang=js"
export * from "./AddCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622c6291",
  null
  
)

export default component.exports